import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";
import { pushNotification } from "utils/notifications";
import { formatNumber, nFormatter, formatMoney } from "utils/currencyFormat";
import CauHinhTaiSanApi from "service/CauHinhTaiSanApi";
import XoaCauHinhGiamTru from "./XoaCauHinhGiamTru";
import ChiTietCauHinhGiamTru from "./ChiTietCauHinhGiamTru";

const CauHinhGiamTruTaiSan = ({ data, onClose }) => {
    const [saving, setSaving] = useState(false);
    const [listHangSanXuat, setListHangSanXuat] = useState([]);
    const [listDongSanPham, setListDongSanPham] = useState([]);
    const [listThuocTinhGiamTru, setListThuocTinhGiamTru] = useState([]);
    const [CauHinhGiamTruID, setCauHinhGiamTruID] = useState(0)
    const CauHinhTaiSanId = data.CauHinhTaiSanId;
    const [TenSanPham, setTenSanPham] = useState("");
    const [DinhGiaSanPham, setDinhGiaSanPham] = useState(0);

    const [HangSanXuatID, setHangSanXuatID] = useState(0);
    const [DongSanPhamID, setDongSanPhamID] = useState(0);
    const [NamSanXuat, setNamSanXuat] = useState(new Date().getFullYear())

    const [HangSanXuatIDSearch, setHangSanXuatIDSearch] = useState("");
    const [DongSanPhamIDSearch, setDongSanPhamIDSearch] = useState("");
    const [NamSanXuatSearch, setNamSanXuatSearch] = useState("")

    const [listSelectedThuocTinhGiamTru, setlistSelectedThuocTinhGiamTru] = useState([])
    const [listRemainThuocTinhGiamTru, setlistRemainThuocTinhGiamTru] = useState([])

    const [ListCauHinhGiamTru, setListCauHinhGiamTru] = useState([]);

    const [ShowModelXoa, setShowModelXoa] = useState(false);
    const [DelID, setDelID] = useState(0);

    const [ShowModelXem, setShowModelXem] = useState(false);
    const [SelectedThuocTinhGiamTruItem, setSelectedThuocTinhGiamTruItem] = useState([]);

    const [errors, setErrors] = useState({});

    const years = [];
    for (let i = new Date().getFullYear(); i >= 1900; i--) {
        years.push(i);
    }
    const handleKeyDown = (event) => {
        if (event.key === "Escape") onClose();
    };
    const loadData = async () => {
        const res = await ThuocTinhGiamTruApi.getDataByCauHinhTaiSanID({ id: CauHinhTaiSanId });
        if (res.data) {
            setListHangSanXuat(res.data.HangSanXuat);
            setHangSanXuatID(res.data.HangSanXuat[0]?.ThongTinGiamTruID || 0);
            setListDongSanPham(res.data.DongSanPham);
            setDongSanPhamID(res.data.DongSanPham[0]?.ThongTinGiamTruID || 0);
            setListThuocTinhGiamTru(res.data.ThuocTinhGiamTru);
            setlistRemainThuocTinhGiamTru(res.data.ThuocTinhGiamTru)
        }
    }
    const [SearchData, setSearchData] = useState({
        CauHinhTaiSanId: data.CauHinhTaiSanId,
        hangSanXuatId: HangSanXuatIDSearch,
        DongSanPhamId: DongSanPhamIDSearch,
        NamSanXuat: NamSanXuatSearch,
    });
    const onSearch = async (data) => {
        try {
            const res = await CauHinhTaiSanApi.SelectCauHinhGiamTruTaiSanByCauHinhTaiSanId(data);
            setListCauHinhGiamTru(res.data || []);
        } catch (error) {
            console.error("Lỗi load danh sách cấu hình giảm trừ:", error);
        }
    };
    useEffect(() => {
        loadData();
        onSearch(SearchData)
        document.addEventListener("keydown", handleKeyDown);

        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);
    const handleChuyen = (item) => {
        setlistSelectedThuocTinhGiamTru((prev) => [...prev, item]);
        setlistRemainThuocTinhGiamTru((prev) =>
            prev.filter((x) => x.ThuocTinhGiamTruId !== item.ThuocTinhGiamTruId)
        );
    };

    const handleXoa = (item) => {
        setlistRemainThuocTinhGiamTru((prev) => [...prev, item]);
        setlistSelectedThuocTinhGiamTru((prev) =>
            prev.filter((x) => x.ThuocTinhGiamTruId !== item.ThuocTinhGiamTruId)
        );
    };

    const resetData = () => {
        setCauHinhGiamTruID(0);
        setNamSanXuat(new Date().getFullYear());
        setTenSanPham("");
        setDinhGiaSanPham(0);
        setlistSelectedThuocTinhGiamTru([]);
        setlistRemainThuocTinhGiamTru(listThuocTinhGiamTru);
    }
    const validate = () => {
        let newErrors = {};
        if (!TenSanPham.trim()) newErrors.TenSanPham = "Nhập tên sản phẩm";
        if (Number(DinhGiaSanPham.toString().replace(/,/g, "")) <= 0) newErrors.DinhGiaSanPham = "Giá sản phẩm > 0";
        if (listSelectedThuocTinhGiamTru.length <= 0) newErrors.listSelectedThuocTinhGiamTru = "( Chọn 1 thuộc tính giảm trừ )";
        if(HangSanXuatID === 0) newErrors.HangSanXuatID = "Chọn hãng sản xuất"
        if(DongSanPhamID === 0) newErrors.DongSanPhamID = "Chọn dòng sản phẩm"
        return newErrors;
    };
    const handleSave = async () => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});
        setSaving(true);

        try {
            const payload = {
                CauHinhTaiSanID: CauHinhTaiSanId,
                CauHinhGiamTruID: CauHinhGiamTruID,
                DongSanPhamID: DongSanPhamID,
                HangSanXuatID: HangSanXuatID,
                NamSanXuat: NamSanXuat,
                TenSanPhamGiamTru: TenSanPham,
                DinhGia: Number(DinhGiaSanPham.toString().replace(/,/g, "")),
                ListThongTinThuocTinhGiamTru: listSelectedThuocTinhGiamTru,
            };
            // console.log("data payload: ", payload);
            const res = await CauHinhTaiSanApi.AddOrUpdateCauHinhGiamTru(payload);
            if (res.status === 200) {
                pushNotification("Lưu thành công", "success", "TOP_CENTER", 1000);
                resetData();
                onSearch(SearchData);
            }
            else {
                pushNotification("Có lỗi xảy ra khi lưu. Vui lòng thử lại.", "error", "TOP_CENTER", 1000);
            }
        }
        catch {
            pushNotification("Có lỗi xảy ra khi gọi api. Vui lòng thử lại.", "error", "TOP_CENTER", 1000);
        }
        setSaving(false);
    }
    const onDelete = async (CauHinhGiamTruID) => {
        try {
            const res = await CauHinhTaiSanApi.DeleteCauHinhGiamTruTaiSanByID({ id: CauHinhGiamTruID });
            if (res.status === 200) {
                pushNotification("Xóa thành công", "success", "TOP_CENTER", 1000);
                setShowModelXoa(false);
                onSearch(SearchData);
            }
            else {
                pushNotification("Có lỗi xảy ra khi xóa. Vui lòng thử lại.", "error", "TOP_CENTER", 1000);
            }
        } catch (err) {
            console.error("Lỗi khi xóa:", err);
            pushNotification("Không thể gọi api xóa. Vui lòng thử lại!", "error", "TOP_CENTER", 1000);
        }
    }

    const handleSearchClick = () => {
        const newSearch = {
            CauHinhTaiSanId: data.CauHinhTaiSanId,
            hangSanXuatId: HangSanXuatIDSearch,
            DongSanPhamId: DongSanPhamIDSearch,
            NamSanXuat: NamSanXuatSearch,
        };
        setSearchData(newSearch);
        onSearch(newSearch);
        resetData();
    }
    const handleSuaCauHinh = (item) => {
        const selectedIds = item.ListThongTinThuocTinhGiamTru.map(x => x.ThuocTinhGiamTruId);
        const selected = listThuocTinhGiamTru.filter(x => selectedIds.includes(x.ThuocTinhGiamTruId));
        const remaining = listThuocTinhGiamTru.filter(x => !selectedIds.includes(x.ThuocTinhGiamTruId));
        setlistSelectedThuocTinhGiamTru(selected);
        setlistRemainThuocTinhGiamTru(remaining);
        setCauHinhGiamTruID(item.CauHinhGiamTruID);
        setTenSanPham(item.TenSanPhamGiamTru);
        setDinhGiaSanPham(formatNumber(item.DinhGia));
        setHangSanXuatID(item.HangSanXuatID);
        setDongSanPhamID(item.DongSanPhamID);
        setNamSanXuat(item.NamSanXuat);
    }
    const handleXoaCauHinh = (item) => {
        setDelID(item.CauHinhGiamTruID);
        setShowModelXoa(true);
    }
    const handleXemCauHinh = (item) => {
        const selectedIds = item.ListThongTinThuocTinhGiamTru.map(x => x.ThuocTinhGiamTruId);
        const selected = listThuocTinhGiamTru.filter(x => selectedIds.includes(x.ThuocTinhGiamTruId));
        setSelectedThuocTinhGiamTruItem(selected);
        setShowModelXem(true);
    }

    return (<>
        <Modal
            show={true}
            size="new-size"
            centered
            className="modal-new modal fade text-left popup-detail"
            backdrop="static"
        >
            <Modal.Header>
                <h4 className="modal-title" style={{ marginTop: "10px", marginLeft: "15px", fontWeight: "bold" }}>
                    <img src="/app-assets/images/icon-donglai.png" />&nbsp;
                    Cấu hình giảm trừ loại tài sản : {data.TenHangHoa}
                </h4>
                <button type="button" className="close-popup-new" onClick={onClose}>
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <h3 className="lead collapsed" style={{ borderBottom: "1px solid black", paddingBottom: "5px",color:"#00B69B", fontWeight: "bold" }}>Thêm mới sản phẩm cấu hình giảm trừ</h3>
                <div className="row" style={{ paddingTop: "5px", fontWeight: "bold" }}>
                    <div className="col-md-6">
                        <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                            <div style={{ flex: "7" }}>
                                <div className="form-group">
                                    <label>Tên sản phẩm</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nhập tên sản phẩm"
                                        value={TenSanPham}
                                        onChange={(e) => setTenSanPham(e.target.value)}
                                    />
                                    {errors.TenSanPham && <div className="text-danger">{errors.TenSanPham}</div>}
                                </div>
                            </div>
                            <div style={{ flex: "3" }}>
                                <div className="form-group">
                                    <label>Định giá</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={DinhGiaSanPham}
                                        onChange={(e) => setDinhGiaSanPham(formatNumber(Number(e.target.value.replace(/\D/g, ""))))}
                                    />
                                    {errors.DinhGiaSanPham && <div className="text-danger">{errors.DinhGiaSanPham}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                            <div style={{ flex: "1" }}>
                                <div className="form-group">
                                    <label>Hãng sản xuất</label>
                                    <select id="HangSanXuat" name="HangSanXuat"
                                        value={HangSanXuatID}
                                        onChange={(e) => setHangSanXuatID(e.target.value)}
                                        className="form-control input-sm">
                                        {listHangSanXuat && listHangSanXuat.map((hsx, index) => (
                                            <option key={index} value={hsx.ThongTinGiamTruID}>
                                                {hsx.TenHangSanXuat}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.HangSanXuatID && <div className="text-danger">{errors.HangSanXuatID}</div>}
                                </div>
                            </div>
                            <div style={{ flex: "1" }}>
                                <div className="form-group">
                                    <label>Dòng sản phẩm</label>
                                    <select id="DongSanPham" name="DongSanPham"
                                        value={DongSanPhamID}
                                        onChange={(e) => setDongSanPhamID(e.target.value)}
                                        className="form-control input-sm">
                                        {listDongSanPham && listDongSanPham.map((hsx, index) => (
                                            <option key={index} value={hsx.ThongTinGiamTruID}>
                                                {hsx.TenDongSanPham}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.DongSanPhamID && <div className="text-danger">{errors.DongSanPhamID}</div>}
                                </div>
                            </div>
                            <div style={{ flex: "1" }}>
                                <div className="form-group">
                                    <label>Năm sản xuất</label>
                                    <select id="NamSanXuat" name="NamSanXuat"
                                        value={NamSanXuat}
                                        onChange={(e) => setNamSanXuat(e.target.value)}
                                        className="form-control input-sm">
                                        {years.map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6" style={{ minHeight: "200px" }}>
                        <div className="form-group">
                            <label><span style={{color:"#00B69B",fontSize:"18px"}}>Thuộc tính giảm trừ</span></label>
                            <div>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "65%" , fontWeight:"bold"}}>Tên thuộc tính</th>
                                            <th style={{ width: "30%", textAlign: "right", fontWeight:"bold" }}>Giá giảm trừ</th>
                                            <th style={{ width: "5%", textAlign: "right", fontWeight:"bold" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listRemainThuocTinhGiamTru && listRemainThuocTinhGiamTru.length > 0 && (
                                            listRemainThuocTinhGiamTru.map((item) => (
                                                <tr key={item.ThuocTinhGiamTruId}>
                                                    <td>{item.TenThuocTinh}</td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {item.TienGiamTru.toLocaleString("vi-VN")}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <button
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={() => handleChuyen(item)}
                                                        >
                                                            <i className="mdi mdi-arrow-right"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6" style={{ minHeight: "200px" }}>
                        <div className="form-group">
                            <label ><span style={{color:"#00B69B", fontSize:"18px"}}>Thuộc tính giảm trừ được chọn</span> {errors.listSelectedThuocTinhGiamTru && <span className="text-danger">{errors.listSelectedThuocTinhGiamTru}</span>}</label>
                            <div>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "65%" , fontWeight:"bold"}}>Tên thuộc tính</th>
                                            <th style={{ width: "30%", textAlign: "right" , fontWeight:"bold"}}>Giá giảm trừ</th>
                                            <th style={{ width: "5%", textAlign: "right" , fontWeight:"bold"}}></th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {listSelectedThuocTinhGiamTru && listSelectedThuocTinhGiamTru.length > 0 && (
                                            listSelectedThuocTinhGiamTru.map((item) => (
                                                <tr key={item.ThuocTinhGiamTruId}>
                                                    <td>{item.TenThuocTinh}</td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {item.TienGiamTru.toLocaleString("vi-VN")}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => handleXoa(item)}
                                                        >
                                                            <i className="mdi mdi-delete"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div style={{ textAlign: "right" }}>
                            <button className="btn" onClick={handleSave} disabled={saving} style={{ background: "#056569", color: "white", borderRadius: "6px", fontSize: "15px", textTransform: "none", maxHeight: "30px" }}>
                                {saving ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm"></span>&nbsp; Đang lưu...
                                    </>
                                ) : (
                                    <>
                                        <img src="/app-assets/images/icon-add-v2.png" />&nbsp; Lưu
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <h3 className="lead collapsed" style={{ borderBottom: "1px solid black", paddingBottom: "5px", color:"#00B69B",fontWeight: "bold" }}>Danh sách sản phẩm giảm trừ</h3>
                <div className="row" style={{ paddingTop: "5px"}}>
                    <div className="col-md-7">
                        <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                            <div style={{ flex: "2" }}>
                                <div className="form-group">
                                    <label><span className="text-bold">Hãng sản xuất</span></label>
                                    <select id="HangSanXuat" name="HangSanXuat"
                                        value={HangSanXuatIDSearch}
                                        onChange={(e) => setHangSanXuatIDSearch(e.target.value)}
                                        className="form-control input-sm">
                                        <option value="">
                                            Hãng sản xuất
                                        </option>
                                        {listHangSanXuat && listHangSanXuat.map((hsx, index) => (
                                            <option key={index} value={hsx.ThongTinGiamTruID}>
                                                {hsx.TenHangSanXuat}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div style={{ flex: "2" }}>
                                <div className="form-group">
                                    <label><span className="text-bold">Dòng sản phẩm</span></label>
                                    <select id="DongSanPham" name="DongSanPham"
                                        value={DongSanPhamIDSearch}
                                        onChange={(e) => setDongSanPhamIDSearch(e.target.value)}
                                        className="form-control input-sm">
                                        <option value="">
                                            Dòng sản phẩm
                                        </option>
                                        {listDongSanPham && listDongSanPham.map((hsx, index) => (
                                            <option key={index} value={hsx.ThongTinGiamTruID}>
                                                {hsx.TenDongSanPham}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div style={{ flex: "2" }}>
                                <div className="form-group">
                                    <label><span className="text-bold">Năm sản xuất</span></label>
                                    <select id="NamSanXuat" name="NamSanXuat"
                                        value={NamSanXuatSearch}
                                        onChange={(e) => setNamSanXuatSearch(e.target.value)}
                                        className="form-control input-sm">
                                        <option value="">
                                            Tất cả
                                        </option>
                                        {years.map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div style={{ flex: "1" }}>
                                <div className="form-group" style={{ display: "flex", flexDirection: "column" }}>
                                    <label htmlFor="submit" className="font-color-default font-bold" >&nbsp;</label>
                                    <button
                                        id="submit"
                                        name="submit"
                                        type="submit"
                                        className="btn btn-info-new"
                                        onClick={handleSearchClick}
                                    >
                                        <i className="la la-search"></i>
                                        <span> &nbsp; Tìm kiếm</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: "20%", textAlign: "center" }}>Hãng sản xuất</th>
                                    <th style={{ width: "20%", textAlign: "center" }}>Dòng sản phẩm</th>
                                    <th style={{ width: "10%", textAlign: "center" }}>Năm sản xuất</th>
                                    <th style={{ width: "20%", textAlign: "center" }}>Sản phẩm</th>
                                    <th style={{ width: "20%", textAlign: "center" }}>Định giá</th>
                                    <th style={{ width: "10%", textAlign: "center" }}>Thao tác</th>
                                </tr>
                            </thead>
                            <tbody >
                                {ListCauHinhGiamTru && ListCauHinhGiamTru.length > 0 && (
                                    ListCauHinhGiamTru.map((item) => (
                                        <tr key={item.CauHinhGiamTruID}>
                                            <td>{item.TenHangSanXuat}</td>
                                            <td>{item.TenDongSanPham}</td>
                                            <td>{item.NamSanXuat}</td>
                                            <td>{item.TenSanPhamGiamTru}</td>
                                            <td style={{ textAlign: "right" }}>
                                                {item.DinhGia.toLocaleString("vi-VN")}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                <button
                                                    className="btn btn-sm btn-outline-success"
                                                    onClick={() => handleXemCauHinh(item)}
                                                    title="Xem chi tiết"
                                                >
                                                    <i className="mdi mdi-notebook"></i>
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => handleSuaCauHinh(item)}
                                                    title="Sửa"
                                                >
                                                    <i className="mdi mdi-pencil-circle"></i>
                                                </button>
                                                {item.isDel && (
                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => handleXoaCauHinh(item)}
                                                        title="Xóa"
                                                    >
                                                        <i className="mdi mdi-delete"></i>
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {ShowModelXem && (<>
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            backgroundColor: "rgba(0,0,0,0.4)",
                            backdropFilter: "blur(6px)",
                            WebkitBackdropFilter: "blur(6px)",
                            zIndex: 2500,
                        }}
                    ></div>
                    <div style={{ zIndex: 4000, position: "relative" }}>
                        <ChiTietCauHinhGiamTru
                            data={SelectedThuocTinhGiamTruItem}
                            onClose={() => setShowModelXem(false)}
                        />
                    </div>
                </>)}
                {
                    ShowModelXoa && (<>
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                backgroundColor: "rgba(0,0,0,0.4)",
                                backdropFilter: "blur(6px)",
                                WebkitBackdropFilter: "blur(6px)",
                                zIndex: 2500,
                            }}
                        ></div>
                        <div style={{ zIndex: 4000, position: "relative" }}>
                            <XoaCauHinhGiamTru
                                CauHinhGiamTruID={DelID}
                                onClose={() => setShowModelXoa(false)}
                                onDelete={onDelete}
                            />
                        </div>
                    </>)
                }
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-new-main btn-closenew" onClick={onClose} disabled={saving}>
                    <i className="mdi mdi-close"></i>&nbsp; Đóng
                </button>
            </Modal.Footer>
        </Modal>
    </>
    );
}

export default CauHinhGiamTruTaiSan;